import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, ButtonGroup, Modal, ModalBody, ModalHeader } from 'reactstrap'
import offers from '../../../../api/offers/hooks'
import { OfferTemplateId } from '../../../../api/offers/types'
import { MODAL_TYPES } from '../../../../common/constants'
import { hideModal } from '../../../../store/modal'
import { OfferPreviewModalProps } from '../types'

const OfferPreviewModal = (props: OfferPreviewModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { isOpen, offerPreviewModal } = props
    const { agentId, offerTemplate, offerType, offerLocale, offerSettingsGroup, pdfUrl, previewCount } = offerPreviewModal

    const { mutate: previewOffer } = offers.PreviewOffer.useMutation()

    const handlePreviewCountChange = (increment: number) => {
        previewOffer({
            previewCount: previewCount + increment,
            data: {
                agent_id: agentId,
                offer_settings_group: offerSettingsGroup,
                offer_template: offerTemplate,
                offer_type: offerType,
                offer_locale: offerLocale,
            },
        })
    }

    const handleNext = () => handlePreviewCountChange(1)
    const handlePrev = () => handlePreviewCountChange(-1)

    const handleClose = () => dispatch(hideModal({ modalType: MODAL_TYPES.OFFER_PREVIEW_MODAL }))

    const renderContent = () => {
        return pdfUrl ? <iframe style={{ width: '100%', height: '600px' }} title="PDF" src={pdfUrl}></iframe> : null
    }

    return (
        <Modal size="lg" isOpen={isOpen} centered>
            <ModalHeader toggle={handleClose}></ModalHeader>
            <div className="modal-header">
                <h5 className="modal-title">{t('modal.offerPrintPreview.title')}</h5>
                <div>
                    {offerTemplate !== OfferTemplateId.PROPERTY_TEMPLATE_3 && (
                        <ButtonGroup>
                            <Button color="link" className="text-decoration-none" disabled={previewCount === 1} onClick={handlePrev}>
                                <i className="mdi mdi-chevron-left label-icon align-middle fs-16 me-1"></i>
                                {t('button.pagination.previous')}
                            </Button>
                            <div
                                style={{
                                    display: 'block',
                                    width: '1px',
                                    backgroundColor: '#E7E9EB',
                                }}
                            />
                            <Button
                                color="link"
                                className="text-decoration-none"
                                disabled={offerSettingsGroup?.length === 1 || offerSettingsGroup?.length === previewCount}
                                onClick={handleNext}
                            >
                                {t('button.pagination.next')}
                                <i className="mdi mdi-chevron-right label-icon align-middle fs-16 ms-1"></i>
                            </Button>
                        </ButtonGroup>
                    )}
                </div>
            </div>
            <ModalBody>{renderContent()}</ModalBody>
        </Modal>
    )
}

export default OfferPreviewModal
